const tokenService = {
    setToken: (token: string) => {
        localStorage.setItem("" + process.env.VUE_APP_AUTH_TOKEN_KEY, token);
    },
    getToken() {
        return localStorage.getItem("" + process.env.VUE_APP_AUTH_TOKEN_KEY);
    },
    removeToken(){
        localStorage.removeItem("" + process.env.VUE_APP_AUTH_TOKEN_KEY);
    },
    setScopeToken: (token: string) => {
        sessionStorage.setItem("" + process.env.VUE_APP_SCOPE_TOKEN_KEY, token);
    },
    getScopeToken() {
        return sessionStorage.getItem("" + process.env.VUE_APP_SCOPE_TOKEN_KEY);
    },

}

export default tokenService;
